import CallMade from '@mui/icons-material/CallMade';
import Home from '@mui/icons-material/Home';
import { Tooltip } from '@mui/material';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import ApreciarLote from './ApreciarLote';
import ApregoarPlanilha from './ApregoarPlanilha';
import AssinarLote from './AssinarLote';
import ComposicaoEmLote from './ComposicaoEmLote';
import ExportarPainelVotacaoSessaoParaArquivoCsv from './ExportarPainelVotacaoSessaoParaArquivoCsv';
import ExportarProcessosParaArquivoCsv from './ExportarProcessosParaArquivoCsv';
import FiltroRapido from './FiltroRapido';
import GerarCertidaoEmLote from './GerarCertidaoEmLote';
import ImportarSalaSessaoLote from './ImportarSalaSessaoLote';
import JulgarPlanilha from './JulgarPlanilha';
import LiberarDispositivoVoto from './LiberarDispositivoVoto';
import LiberarProcessosApreciadosLote from './LiberarProcessosApreciadosLote';
import ModalEnviarProcessosEmLotePJe from './ModalEnviarProcessosEmLotePJe';
import ModalErrosEnvioLotePJe from './ModalErrosEnvioLotePJe';
import MovimentoDecisaoLote from './MovimentoDecisaoLote';
import OrdenacaoProcessos from './OrdenacaoProcessos';
import TipoJulgamentoLote from './TipoJulgamentoLote';
import ExportarRelatorioComparacaoCertidaoAcordao from './toolbar/ExportarRelatorioComparacaoCertidaoAcordao';
import AtualizarDecisaoLote from './AtualizarDecisaoLote';

export const ref = React.createRef();

class FerramentasListaProcessos extends ReactComponent {
    openModalProcessosEmLote = false;

    search = (event) => {
        event.preventDefault();
        const element = document.getElementById('numero');

        if (element) {
            element.focus();
        } else {
            console.log('Elemento `numero` indisponível.');
        }
    };

    abrirModalProcessosEmLote = () => {
        this.openModalProcessosEmLote = true;
    };

    onCloseModalProcessosEmLotePJe = () => {
        this.openModalProcessosEmLote = false;
    };

    onCloseModalErrosEnvioLotePJe = () => {
        this.salaSessaoStore.abrirMensagemErroLote = false;
    };

    handleClickHome = () => {
        this.salaSessaoStore.posicionarProcessosEmExibicaoPeloIndice(0);
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            openModalProcessosEmLote: observable,
            search: action,
            abrirModalProcessosEmLote: action,
            onCloseModalProcessosEmLotePJe: action,
            onCloseModalErrosEnvioLotePJe: action,
            tituloTooltipEnviarProcessos: computed
        });
    }

    /**
     * Monta e retorna o título do botão "Enviar Processos".
     * @returns {string} O título do botão "Enviar Processos"
     */
    get tituloTooltipEnviarProcessos() {
        if (this.isComponenteHabilitado('EnvioAcordaoSIJ')) {
            if (this.salaSessaoStore.isSessaoMista()) {
                return 'Enviar processos para o sistema de origem';
            }

            if (this.salaSessaoStore.existeSessaoSIJ) {
                return 'Enviar processos para o eSIJ';
            }
        }

        return 'Enviar processos para o PJe';
    }

    render() {
        return (
            <div
                id="divFerramentasListaProcessos"
                style={{ display: 'flex', margin: '0px 10px', justifyContent: 'space-between', alignItems: 'center' }}
            >
                {this.openModalProcessosEmLote && (
                    <ModalEnviarProcessosEmLotePJe
                        open={this.openModalProcessosEmLote}
                        onClose={this.onCloseModalProcessosEmLotePJe}
                        processos={this.salaSessaoStore.processosApreciadosFiltrados}
                    />
                )}
                {this.salaSessaoStore.abrirMensagemErroLote && (
                    <ModalErrosEnvioLotePJe
                        open={this.salaSessaoStore.abrirMensagemErroLote}
                        onClose={this.onCloseModalErrosEnvioLotePJe}
                    />
                )}
                <div
                    style={{
                        display: 'flex',
                        flexGrow: '1',
                        justifyContent: 'space-between',
                        zIndex: '999',
                        margin: '2px 0px'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexGrow: '1',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            margin: '5px',
                            justifyContent: 'flex-start'
                        }}
                    >
                        <OrdenacaoProcessos />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexGrow: '1',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            margin: '5px',
                            justifyContent: 'flex-end'
                        }}
                    >
                        <div className="corBotao">
                            <Tooltip
                                title={'Ir para o início da página'}
                                placement="top-start"
                            >
                                <Home
                                    onClick={this.handleClickHome}
                                    style={{ marginRight: '10px', cursor: 'pointer' }}
                                />
                            </Tooltip>
                        </div>
                        {this.salaSessaoStore.idProcessosEmExibicao === 'P' && (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-evenly',
                                    alignItems: 'center',
                                    zIndex: '999'
                                }}
                            >
                                <ImportarSalaSessaoLote />
                                <AtualizarDecisaoLote />
                                <ApregoarPlanilha />
                                <JulgarPlanilha />
                                <ApreciarLote />
                            </div>
                        )}
                        {this.salaSessaoStore.idProcessosEmExibicao !== 'P' && (
                            <div
                                className="corBotao"
                                style={{ display: 'flex', flexDirection: 'row' }}
                            >
                                <GerarCertidaoEmLote />
                                <AssinarLote />
                                <span
                                    style={{
                                        display:
                                            this.isComponenteHabilitado('EnvioAcordaoSIJ') ||
                                            this.salaSessaoStore.existeSessaoPJe
                                                ? 'initial'
                                                : 'none'
                                    }}
                                >
                                    <Tooltip
                                        title={this.tituloTooltipEnviarProcessos}
                                        placement="top-start"
                                    >
                                        <CallMade
                                            onClick={this.abrirModalProcessosEmLote}
                                            style={{ marginRight: '10px', cursor: 'pointer' }}
                                        />
                                    </Tooltip>
                                </span>
                                <LiberarDispositivoVoto />
                                <LiberarProcessosApreciadosLote />
                            </div>
                        )}
                        <ComposicaoEmLote />
                        <TipoJulgamentoLote />
                        <MovimentoDecisaoLote />
                        <ExportarProcessosParaArquivoCsv />
                        <ExportarPainelVotacaoSessaoParaArquivoCsv />
                        <ExportarRelatorioComparacaoCertidaoAcordao />
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                            <PainelFiltros />
                        </div>
                    </div>
                    <FiltroRapido id="filtroRapidoListaProcessos" />
                </div>
            </div>
        );
    }
}

export default inject('stores')(observer(FerramentasListaProcessos));
